import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://vjeqzczbkdqzqlpvxuem.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqZXF6Y3pia2RxenFscHZ4dWVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMyNTUyMzQsImV4cCI6MjA3ODgzMTIzNH0.dco1YrfG_t49caC5mWXNfOGblWNuoQlT3K17IHG2k-E'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})